import React from "react";
import { MapPin, Phone, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-neutral-300 mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4" data-testid="footer-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_pho-express-lausanne/artifacts/gp5qekfl_logoquang1.png"
              alt="Chez Quang"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="text-sm leading-relaxed text-neutral-400 max-w-md">
            Cuisine vietnamienne traditionnelle au cœur de Lausanne. Phở fumants, Bò Bún généreux, nems
            croustillants — préparés avec soin et livrés chez vous.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2" data-testid="footer-address">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D90429]" />
              <span>
                <span className="block text-[10px] uppercase tracking-wider text-[#E9C46A] font-bold mb-0.5">Nouvelle adresse</span>
                Rue Pré-du-Marché 15<br />1004 Lausanne
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#D90429]" />
              <a href="tel:+41786162929" className="hover:text-white">078 616 29 29</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-bold mb-4">Horaires</h4>
          <ul className="space-y-1.5 text-sm">
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#D90429]" /> Tous les jours</li>
            <li className="ml-6 text-neutral-400">10:00 — 22:00</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-5 text-xs text-neutral-500 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Quang — Restaurant Vietnamien</span>
          <span>Made with care in Lausanne</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
